import {
  HttpErrorResponse,
  HttpInterceptorFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { APP_ROUTES } from '@core/constants';
import { AuthService } from '@core/services';
import { catchError, from, switchMap, throwError } from 'rxjs';

let refreshInFlight: Promise<string> | null = null;

export const httpAuthRefreshInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const isAuthEndpoint = req.url.includes('/auth/login') || req.url.includes('/auth/refresh');
  if (isAuthEndpoint) {
    return next(req);
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401) {
        return throwError(() => error);
      }

      const refreshToken = auth.getRefreshToken();
      if (!refreshToken) {
        auth.clearSession();
        router.navigate([APP_ROUTES.LOGIN]);
        return throwError(() => error);
      }

      if (!refreshInFlight) {
        refreshInFlight = auth
          .refreshAccessToken(refreshToken)
          .then((tokens) => tokens.accessToken)
          .finally(() => {
            refreshInFlight = null;
          });
      }

      return from(refreshInFlight).pipe(
        switchMap((accessToken) => {
          const retry = req.clone({
            setHeaders: {
              Authorization: `Bearer ${accessToken}`,
            },
          });
          return next(retry);
        }),
        catchError((refreshError) => {
          auth.clearSession();
          router.navigate([APP_ROUTES.LOGIN]);
          return throwError(() => refreshError);
        }),
      );
    }),
  );
};
